// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"0f559c5f","161":"8650f566","213":"9d521569","239":"d9d04dfb","446":"ea89dba8","543":"c4acde4c","693":"1d4c02a5","706":"aac0ab18","935":"c2534bc8"}[chunkId] + ".chunk.js";
};